// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"508":"8244eb08","521":"66eb42df","744":"7a2a4741","878":"f3651a41"}[chunkId] + ".chunk.js";
};